import React, { useState, useContext } from 'react';
import './modal.css';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import SearchIcon from '../../assets/search.svg';
import { Loader } from '../loader/Loader';
import TransContext from '../../context/trans/TransContext';

export const Rides = ({ setData, setInput }) => {
  const {
    getUsersRides,
    setSelectedUser,
    loadingProcess,
    setLoadingProcess,
    isCorporate,
    setIsCorporate,
  } = useContext(TransContext);
  const [inputData, setInputData] = useState('');
  const [user, setUser] = useState('');
  const [usersData, setUsersData] = useState([]);
  const [selectOption, setSelectOption] = useState('name');
  const [results, setResults] = useState(null);

  // to set input data
  const onChange = (e) => {
    setInputData(e.target.value);
  };

  const onSwitchCorporate = (e) => {
    setUsersData([]);
    setInputData('');
    setIsCorporate(e.target.checked);
  };

  const selectUser = (user) => {
    setUser(user);
    setSelectedUser(user);
    if (!isCorporate) {
      setData(user.first_name);
    } else {
      setData(user.name);
    }
  };

  const filter_users = async () => {
    const res = await getUsersRides(selectOption, inputData.toString());
    // console.log("Received user data")
    // console.log(res.data);
    // console.log("Received user data")
    setUsersData(res);
    if (res.length === 0) {
      setResults(true);
      setLoadingProcess(false);
    } else setResults(false);
  };

  const cleanUSer = () => {
    setUser('');
    setData('');
    setInput('');
    setInputData('');
    setUsersData([]);
    setIsCorporate(false);
  };

  return (
    <>
      <div style={{ width: '100%' }}>
        {user ? (
          <div className="user-selected-conatiner">
            <HighlightOffIcon
              className="close-btn"
              style={{ position: 'absolute', right: 20 }}
              onClick={() => cleanUSer()}
            />

            <p>
              Nombre:{' '}
              <span className="user-span">
                {isCorporate ? user.name : user.first_name}
              </span>
            </p>
            <p>
              Correo: <span className="user-span">{user.email}</span>
            </p>
            <p>
              Telefono: <span className="user-span">{user.phone}</span>
            </p>
            <p>
              ID: <span className="user-span">{user.unique_id}</span>
            </p>
          </div>
        ) : (
          <>
            {/* switch de usuarios corportate  */}
            <div className="flex-box">
              <label className="switch">
                <input type="checkbox" onChange={(e) => onSwitchCorporate(e)} />
                <span className="slider round"></span>
              </label>
              <p className="text-center title-modal">Corporate</p>
            </div>
            {/* switch de usuarios corportate  */}

            <p className="input-label">Buscar usuario</p>
            <div className="search-user-container">
              <select
                className="select-user"
                onChange={(e) => setSelectOption(e.target.value)}>
                <option value="name">Nombre</option>
                <option value="phone">Telefono</option>
                <option value="id">ID</option>
              </select>
              <input
                className="input-user"
                id="search-engine"
                type={selectOption === "name" ? "text" : "number"}
                value={inputData}
                onChange={(e) => onChange(e)}
              />
              <div className="search-user" onClick={filter_users}>
                {loadingProcess ? (
                  <Loader color="#fff" />
                ) : (
                  <img src={SearchIcon} className="search-icon" />
                )}
              </div>
            </div>
            <div className="table-container">
              <table className="users-table">
                <thead className="users-head">
                  <tr>
                    <th className="user-td" style={{ width: 50 }}>
                      ID
                    </th>
                    <th className="user-td">Nombre</th>
                    <th className="user-td">Apellido</th>
                    <th className="user-td">Telefono</th>
                  </tr>
                </thead>
                <tbody>
                  {usersData.map((user) => {
                    return (
                      <tr className="user-tr" onClick={() => selectUser(user)}>
                        <td className="user-td" style={{ width: 50 }}>
                          {user.unique_id}
                        </td>
                        <td className="user-td">
                          {isCorporate ? user.name : user.first_name}
                        </td>
                        <td className="user-td">{user.last_name}</td>
                        <td className="user-td">{user.phone}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {results && (
              <p className="no-coincidence">
                No se encontraron coincidencias...
              </p>
            )}
          </>
        )}
      </div>
    </>
  );
};
